import {ScaleInfo} from './ScaleInfo';

declare let THREE: any;

export class WorldSpaceOffsetCalculator {

  private offset = new THREE.Vector3();

  calculate(scaleInfo: ScaleInfo, lengthOffset: number, heightOffset: number) {
    const distance = this.offset.set(lengthOffset, heightOffset, 0)
      .multiply(scaleInfo.localScaleDirection)
      .length();
    return this.offset.copy(scaleInfo.worldScaleDirection)
      .multiplyScalar(distance);
  }

}





// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/WorldSpaceOffsetCalculator.ts